// Rules to match imported header names with the ones used by bobbee
// patterns is a dictionary that contains common imported header names
export const rules = {
    FEC: {
        rules: [
            {
                column: "type",
                patterns: [/^type$/i],
            },
            {
                column: "JournalCode",
                patterns: [/journalcode/i, /^log$/i, /code journal/i, /^jnal$/i],
            },
            {
                column: "JournalLib",
                patterns: [/journallib/i, /^journal$/, /libell[eé�] du journal/i, /jnal/i],
            },
            {
                column: "EcritureNum",
                patterns: [/[ée]criturenum/i, /^id$/i, /n° de ligne/i],
            },
            {
                column: "EcritureLib",
                patterns: [
                    /[ée]criturelib/i,
                    /^wording$/i,
                    /libell[ée] compte auxiliaire/i,
                    /^libell[ée]s{0,1}$/i,
                    /libell[ée] [eé�]criture/i,
                ],
            },
            {
                column: "EcritureDate",
                patterns: [/[ée]crituredate/i],
            },
            {
                column: "DateLet",
                patterns: [/^datelet$/i],
            },
            {
                column: "ValidDate",
                patterns: [/validdate/i],
            },
            {
                column: "CompteNum",
                patterns: [
                    /comptenum/i,
                    /aaname/i,
                    /num[ée]ro(?: de | )compte/i,
                    /^compte$/i,
                    /n compte/i,
                    /^compte$/i,
                    /^accountableaccount$/i,
                ],
            },
            {
                column: "CompteLib",
                patterns: [
                    /comptelib/i,
                    /^aawording$/i,
                    /nom(?: d[eu] | )compte/i,
                    /intitul[ée](?: d[eu] | )compte/i,
                    /libell[eé�] de compte/i,
                ],
            },
            {
                column: "PieceRef",
                patterns: [
                    /pi[èe]ceref/i,
                    /^invoice\s*number$/i,
                    /num[ée]ro(?: de | )pi[èe]ce/i,
                    /^num[ée]ro(?: de | )facture$/i,
                    /num[ée]ro de note de frais/i,
                    /^pi[èe]ce$/i,
                    /num[eé�]ro de facture/i,
                    /^itemreference$/i,
                ],
            },
            {
                column: "PieceDate",
                patterns: [
                    /pi[èe]cedate/i,
                    /^date$/i,
                    /^dte$/i,
                    /date(?: de | )pi[èe]ce/i,
                    /date(?: d'| )[ée]mission/i,
                    /date du paiement/i,
                    /date de la dépense/i,
                ],
            },
            {
                column: "fileName",
                patterns: [
                    /filename/i,
                    /Nom du fichier/i,
                    /nom (du|des) reçus{0,1}$/i,
                    /nom du\/des reçu\(s\)/i,
                ],
            },
            {
                column: "url",
                patterns: [/^url$/i, /lien document/i],
            },
            {
                column: "Debit",
                patterns: [/d[ée]bit/i],
            },
            {
                column: "Credit",
                patterns: [/cr[ée]dit/i],
            },
            {
                column: "amount",
                patterns: [/amount/i, /montant/i],
            },
            {
                column: "debitCredit",
                patterns: [/(d([\/]|[-]|[_])?c)/i],
            },
            {
                column: "CompAuxLib",
                patterns: [
                    /auxiliare/i,
                    /auxi[l]{1,2}iaire/i,
                    /compauxlib/i,
                    /thirdpartycompany/i,
                    /mode(?: de | )r[èe]glement/i,
                    /fournisseur/i,
                ],
            },
            {
                column: "firstname",
                patterns: [/firstname/i, /^pr[ée]nom/i],
            },
            {
                column: "lastname",
                patterns: [/lastname/i, /^nom/i],
            },
            {
                column: "user",
                patterns: [/^user$/i, /^payeur$/i],
            },
            {
                column: "thirdParty",
                patterns: [/^thirdparty$/i],
            },
            {
                column: "tag1",
                patterns: [/tag\s*1/i, /axe\s*(1|01)/i, /[ée]tiquette\s*1/i, /code analytique 1/i],
            },
            {
                column: "tag2",
                patterns: [/tag\s*2/i, /axe\s*(2|02)/i, /[ée]tiquette\s*2/i, /code analytique 2/i],
            },
            {
                column: "tag3",
                patterns: [/tag\s*3/i, /axe\s*(3|03)/i, /[ée]tiquette\s*3/i, /code analytique 3/i],
            },
            {
                column: "tag4",
                patterns: [/tag\s*4/i, /axe\s*(4|04)/i, /[ée]tiquette\s*4/i, /code analytique 4/],
            },
            {
                column: "dueDate",
                patterns: [/[ée]ch[ée]ance/i, /date [ée]ch/i, /due date/i, /duedate/i],
            },
        ],
    },
    CLIENT_COMPANIES: {
        rules: [
            {
                column: "name",
                patterns: [/compagnie/i, /company/i, /nom/i, /name/i, /raison\s?(sociale?)?/i],
            },
            {
                column: "siret",
                patterns: [/siret/i, /siretclient/i, /num[eé�]ro siret/i],
            },
            {
                column: "siren",
                patterns: [/siren/i, /sirenclient/i, /num[eé�]ro siren/i],
            },
            {
                column: "legalForm",
                patterns: [/legalForm/i, /forme juridique/i],
            },
            {
                column: "legalFormCategory",
                patterns: [/cat[ée]gorie/i, /legalFormCategory/i],
            },
            {
                column: "city",
                patterns: [/city/i, /ville/i],
            },
            {
                column: "country",
                patterns: [/country/i, /pays/i],
            },
            {
                column: "postalCode",
                patterns: [/(?=.*(code))(?=.*(postal))/i],
            },
            {
                column: "address",
                patterns: [/address/i, /adresse/i],
            },
            {
                column: "vatNumber",
                patterns: [/num[ée]ro tva/i, /vatnumber/i],
            },
            {
                column: "activity",
                patterns: [/activit[ée]s/i, /activities/i, /code ape/i, /code naf/i],
            },
            {
                column: "vatSystem",
                patterns: [/r[ée]gime tva/i],
            },
            // Iban	BIC	RUM
            {
                column: "iban",
                patterns: [/iban/i],
            },
            {
                column: "bic",
                patterns: [/bic/i],
            },
            {
                column: "rum",
                patterns: [/rum/i],
            },
            //
            // contact
            //
            {
                column: "firstname",
                patterns: [/pr[eé�]nom/i],
            },
            {
                column: "lastname",
                patterns: [/nom/i, /Repr[eé�]sentant l[eé�]gal/i],
            },
            {
                column: "email",
                patterns: [/email/i, /courriel/i],
            },
            {
                column: "phoneNumber",
                patterns: [/t[eé�]l[eé�]phone/i],
            },
            {
                column: "mobileNumber",
                patterns: [/portable/i],
            },
            {
                column: "thirdPartyCompanyPaymentType",
                patterns: [/mode de r[eè]glement/i, /regl/i],
            },
            //
            // taxSystem //
            //
            // {
            //     "column": "taxSystem",
            //     "patterns": [/statut fiscal/i]
            // }
        ],
    },
    CHILD_COMPANIES: {
        rules: [
            {
                column: "name",
                patterns: [/raison sociale/i, /compagnie/i, /company/i, /nom/i, /name/i],
            },
            {
                column: "siret",
                patterns: [/siret/i, /siretclient/i, /num[eé�]ro siret/i],
            },
            {
                column: "siren",
                patterns: [/siren/i, /sirenclient/i, /num[eé�]ro siren/i],
            },
            {
                column: "legalForm",
                patterns: [/legalForm/i, /forme juridique/i],
            },
            {
                column: "legalFormCategory",
                patterns: [/cat[ée]gorie/i, /legalFormCategory/i],
            },
            {
                column: "city",
                patterns: [/city/i, /ville/i],
            },
            {
                column: "country",
                patterns: [/country/i, /pays/i],
            },
            {
                column: "postalCode",
                patterns: [/(?=.*(code))(?=.*(postal))/i],
            },
            {
                column: "address",
                patterns: [/address/i, /adresse/i],
            },
            {
                column: "vatNumber",
                patterns: [/num[ée]ro tva/i, /vatnumber/i],
            },
            {
                column: "activity",
                patterns: [/activit[ée]s/i, /activities/i, /code ape/i, /code naf/i],
            },
            {
                column: "vatSystem",
                patterns: [/r[ée]gime tva/i],
            },
            // Iban	BIC	RUM
            {
                column: "iban",
                patterns: [/iban/i],
            },
            {
                column: "bic",
                patterns: [/bic/i],
            },
            {
                column: "rum",
                patterns: [/rum/i],
            },
            {
                column: "rumDate",
                patterns: [/date(?: de | )signature/i, /rumdate/i],
            },
            //
            // contact
            //
            {
                column: "firstname",
                patterns: [/pr[eé�]nom/i],
            },
            {
                column: "lastname",
                patterns: [/nom/i, /Repr[eé�]sentant l[eé�]gal/i],
            },
            {
                column: "email",
                patterns: [/email/i, /courriel/i],
            },
            {
                column: "phoneNumber",
                patterns: [/t[eé�]l[eé�]phone/i],
            },
            {
                column: "mobileNumber",
                patterns: [/portable/i],
            },
            {
                column: "thirdPartyCompanyPaymentType",
                patterns: [/mode de r[eè]glement/i, /regl/i],
            },
            {
                column: "tag",
                patterns: [/[eé�]tiquette(s)?/i, /tag(s)?/i],
            },
            //
            // taxSystem //
            //
            // {
            //     "column": "taxSystem",
            //     "patterns": [/statut fiscal/i]
            // }
        ],
    },
    INVOICE_PRODUCTS: {
        rules: [
            {
                column: "title",
                patterns: [/nom du produit/i, /name/i, /nom/i, /title/i, /libell[eé�]/i],
            },
            {
                column: "unitPrice",
                patterns: [/prix[ ]?unitaire/i, /prix/i, /price/i, /unit[ ]?price/i, /tarif/i],
            },
            {
                column: "vatRate",
                patterns: [/tva/i, /vatRate/i],
            },
            {
                column: "reference",
                patterns: [/r[eé�]f[eé�]rence/i],
            },
        ],
    },
    STOCK_PRODUCTS: {
        rules: [
            {
                column: "title",
                patterns: [/nom du produit/i, /name/i, /nom/i, /title/i],
            },
            {
                column: "unitPrice",
                patterns: [/prix[ ]?unitaire/i, /prix/i, /price/i, /unit[ ]?price/i],
            },
            {
                column: "type",
                patterns: [/type/i],
            },
            {
                column: "reference",
                patterns: [/r[eé�]f[eé�]rence/i],
            },
        ],
    },
    SALES_INVOICE: {
        rules: [
            {
                column: "company",
                patterns: [/compagnie/i, /company/i, /client/i, /soci[ée]t[ée]/i],
            },
            {
                column: "siret",
                patterns: [/siret/i, /siretclient/i],
            },
            {
                column: "netAmount",
                patterns: [/prix\s?\(?ht\)?|ht/i, /netamount/i],
            },
            {
                column: "grossAmount",
                patterns: [/prix\s?\(?ttc\)?|ttc/i, /grossamount/i],
            },
            {
                column: "vatAmount",
                patterns: [/prix\s?\(?tva\)?/i, /montant tva/i, /vatamount/i],
            },
            {
                column: "vatRate",
                patterns: [/^tva$/i, /vatrate/i, /^taux$/i],
            },
            {
                column: "date",
                patterns: [/date(?: de | )vente/i, /^date$/i, /date(?: de | )facture/i],
            },
            {
                column: "dueDate",
                patterns: [/date(?: d'| )[ée]ch[ée]ance/i, /duedate/i],
            },
            {
                column: "invoiceNumber",
                patterns: [
                    /num[eé�]ro(?: de)?(?: facture)?/i,
                    /invoicenumber/i,
                    /num(?: de | )facture/i,
                ],
            },
            {
                column: "name",
                patterns: [/libell[eé�](?: de | )facture/i, /libell[eé�]/i],
            },
            {
                column: "netAmount1",
                patterns: [/sous-total/i, /netamount1/i],
            },
            {
                column: "information",
                patterns: [/information/i],
            },
            {
                column: "vatType",
                patterns: [/type(?: de| )tva/i, /vattype/i],
            },
            {
                column: "tag",
                patterns: [/[eé�]tiquette(s)?/i, /tag(s)?/i],
            },
            {
                column: "salesAccountName",
                patterns: [/comptenum/i, /aaname/i, /num[ée]ro(?: de | )compte/i, /^compte$/i],
            },
            {
                column: "salesAccountDescription",
                patterns: [/description(?: de | )compte/i, /description/i],
            },
        ],
    },
    BANK_STATEMENT: {
        rules: [
            {
                column: "date",
                patterns: [/^date$/i, /date comptable/i],
            },
            {
                column: "dateRealization",
                patterns: [/compteLib/i, /aawording/i],
            },
            {
                column: "wording",
                patterns: [
                    /^libell[ée]$/i,
                    /transactions/i,
                    /nature(?: des | )op[ée]rations/i,
                    /libellé(?: des | )opérations/i,
                    /^op[ée]ration/i,
                    /vos op[ée]rations/i,
                ],
            },
            {
                column: "amount",
                patterns: [/amount/i, /montant/i],
            },
            {
                column: "debit",
                patterns: [/d[ée]bit/i, /d[ée]bit euros/i],
            },
            {
                column: "credit",
                patterns: [/cr[ée]dit/i, /cr[ée]dit euros/i],
            },
        ],
    },
    FIXED_ASSETS: {
        rules: [
            {
                column: "aaNameFixedAsset",
                patterns: [/C(?:\/|ompte\s)(?:d')?immo/i],
            },
            {
                column: "aaNameDepreciation", // ** linéaire
                patterns: [/C(?:\/|ompte\s)?(?:d')?amo(?:rtissement)?(?:\sL)?(?:in[é�e]aire)?/i],
            },
            {
                column: "wording",
                patterns: [/D[é�e]signation/i, /Libell[é�e]/i, /Nom/i, /Description/i],
            },
            {
                column: "date",
                patterns: [/Date\s(?:d')?acquis(?:ition)?/i, /Acquis le/i],
            },
            {
                column: "linearSpreadStartDate",
                patterns: [/(?:Date\s)?(?:de\s)?mise\sen\sservice/i],
            },
            // {
            //     "column": "alNetAmountSigned",
            //     "patterns": [/Prix(?: d'| )acquisition TTC/i]
            // },
            {
                column: "alNetAmountSigned",
                patterns: [
                    /Prix\s(?:d')?(acquisition|achat|acquis)(?:\s)?(?:H)?(?:.)?(?:T)?(?:.)?/i,
                ],
            },
            {
                column: "urlLinkToDcoument",
                patterns: [
                    /(url|doc(?:ument)?|link|fichier|pj)/i,
                ],
            },
            {
                column: "alVatAmountSigned",
                patterns: [/^T(?:.)?V(?:.)?A(?:.)?(?: d[é�e]d)?(?:uite)?(?:uctible)?/i],
            },
            {
                column: "depreciableAmountSigned",
                patterns: [/Base\samo(?:rtissable)?/i],
            },
            {
                column: "type",
                patterns: [/^Mode$/i, /^M[é�e]thode/i, /^M$/i, /^Type/i, /^T$/i],
            },
            {
                column: "rate",
                patterns: [/^T(?:au)?(?:x)?|%/i],
            },
            {
                column: "selectedYearDuration",
                patterns: [/^D(?:ur[é�e]e)?/i],
            },
            {
                column: "previousDepreciationAmountSigned", // ** Linéaire
                patterns: [
                    /Cumul\samo(?:rtissement|rtissements|rt|s)?(?:\sL)?(?:in[é�e]aire)?(?:\s\(fin\sN-1\))?/i,
                ],
            },
            {
                column: "aaNameDerogation", // ** Dérogatoire
                patterns: [/^C(?:\/|ompte\s)(?:d')?amo(?:rtissement)?\sd(?:[é�e]rogatoire)?/i],
            },
            {
                column: "previousDerogationDepreciationAmountSigned", // ** Dérogatoire
                patterns: [
                    /Cumul\samo(?:rtissement|rtissements|rt|s)?\sd(?:[é�e]rogatoires|[é�e]rogatoire)?(?:\s\(fin\sN-1\))?/i,
                ],
            },
            {
                column: "previousVNC",
                patterns: [
                    /^V(?:aleur\s)?N(?:ette\s)?(?:C)?(?:omptable)?(?:\s)?(?:\(fin\sN-1\))?/i,
                ],
            },
        ],
    },
    ACCOUNTING_PLAN: {
        rules: [
            {
                column: "name",
                patterns: [/nom/i, /name/i, /num[eé�]ro(?: de| )compte/i, /compte/i],
            },
            {
                column: "description",
                patterns: [/description/i, /libell[eé�]s?/i],
            },
            {
                column: "lettering",
                patterns: [/lettrage/i, /(à|a)? ?lettrer/i],
            },
            {
                column: "bankAccount",
                patterns: [/compte bancaire/i, /banque/i],
            },
            {
                column: "user",
                patterns: [/user/i, /utilisateur/i],
            },
            {
                column: "thirdPartyCompany",
                patterns: [/soci[eé�]t[eé�]? ?tiers/i],
            },
        ],
    },
};
